"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue3_compat_1 = require("@/client/vue3-compat");
const AppButton_vue_1 = require("@/client/components/common/AppButton.vue");
exports.default = (0, vue3_compat_1.defineComponent)({
    name: 'SelectResource',
    props: {
        playerView: {
            type: Object,
            required: true,
        },
        playerinput: {
            type: Object,
            required: true,
        },
        onsave: {
            type: Function,
            required: true,
        },
        showsave: {
            type: Boolean,
        },
        showtitle: {
            type: Boolean,
        },
    },
    data() {
        return {
            unit: undefined,
        };
    },
    components: {
        AppButton: AppButton_vue_1.default,
    },
    methods: {
        canSave() {
            return this.unit !== undefined;
        },
        saveData() {
            if (this.unit === undefined) {
                return;
            }
            this.onsave({ type: 'resource', resource: this.unit });
        },
    },
});
